import dayjs from "dayjs";

export class Helpers {
  static isRepublicDay(): boolean {
    const now = dayjs();
    const startDate = dayjs("2023-10-29 09:00:00");
    const endDate = dayjs("2023-10-29 23:59:59");
    return +startDate <= +now && +now <= +endDate;
  }
}
